export class Material {
  constructor({
    id = null,
    descricao = null,
    arquivos = Array(),
    formacao = Array,
  }) {
    this.id = id;
    this.descricao = descricao;
    this.arquivos = arquivos;
    this.formacao = formacao
  }
  static Build() {
    return new Material({
        id: null,
        descricao: null,
        arquivos: Array(),
        formacao: Array(),
    });
  }
  format() {
    return this;
  }
}
